export type SimplificationEffectInput = {
  attribute: string;
  document: Document;
  value: string;
  variable: string;
};

export type ResetSimplificationEffectInput = Omit<
  SimplificationEffectInput,
  "value"
>;

const styleSelector = 'style[data-migrosone-a11y-page-effects="simplification"]';

const pageScope = "body > :not(#migrosone-a11y-widget-root)";

const simplificationEffectStyles = `
html[data-migrosone-a11y-simplification-effects][data-migrosone-a11y-hide-images] ${pageScope} img,
html[data-migrosone-a11y-simplification-effects][data-migrosone-a11y-hide-images] ${pageScope} picture img,
html[data-migrosone-a11y-simplification-effects][data-migrosone-a11y-hide-images] ${pageScope} img[srcset],
html[data-migrosone-a11y-simplification-effects][data-migrosone-a11y-hide-images] ${pageScope} img[loading="lazy"],
html[data-migrosone-a11y-simplification-effects][data-migrosone-a11y-hide-images] ${pageScope} svg[role="img"],
html[data-migrosone-a11y-simplification-effects][data-migrosone-a11y-hide-images] ${pageScope} video[poster],
html[data-migrosone-a11y-simplification-effects][data-migrosone-a11y-hide-images] ${pageScope} canvas {
  visibility: var(--migrosone-a11y-image-visibility, hidden);
  opacity: var(--migrosone-a11y-image-opacity, 0);
  filter: var(--migrosone-a11y-image-filter, none);
}

html[data-migrosone-a11y-simplification-effects][data-migrosone-a11y-pause-animations] ${pageScope},
html[data-migrosone-a11y-simplification-effects][data-migrosone-a11y-pause-animations] ${pageScope} * {
  animation-play-state: paused !important;
  animation-play-state: var(--migrosone-a11y-animation-play-state, paused) !important;
  animation-duration: var(--migrosone-a11y-animation-duration, inherit) !important;
  animation-delay: var(--migrosone-a11y-animation-delay, inherit) !important;
  transition-duration: var(--migrosone-a11y-transition-duration, inherit) !important;
  transition-delay: var(--migrosone-a11y-transition-delay, inherit) !important;
}
`;

function canUseDocument(document: Document) {
  return Boolean(document.head && document.body && document.documentElement);
}

function ensureSimplificationEffectStyle(document: Document) {
  const existing = document.querySelector(styleSelector);
  if (existing) {
    return true;
  }

  const style = document.createElement("style");
  style.setAttribute("data-migrosone-a11y-page-effects", "simplification");
  style.textContent = simplificationEffectStyles;
  document.head.appendChild(style);
  return true;
}

export function applySimplificationEffectValue({
  attribute,
  document,
  value,
  variable,
}: SimplificationEffectInput) {
  if (!canUseDocument(document)) {
    return false;
  }

  ensureSimplificationEffectStyle(document);
  document.documentElement.style.setProperty(variable, value);
  document.documentElement.setAttribute(attribute, "true");
  document.documentElement.setAttribute(
    "data-migrosone-a11y-simplification-effects",
    "true",
  );
  return true;
}

export function resetSimplificationEffectValue({
  attribute,
  document,
  variable,
}: ResetSimplificationEffectInput) {
  if (!canUseDocument(document)) {
    return false;
  }

  document.documentElement.style.removeProperty(variable);
  document.documentElement.removeAttribute(attribute);
  return true;
}
